import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { InputsDarkTheme } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

export function PostPurchaseGallery() {
  const {
    props: {
      settings: { showGallery },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const options: DropdownInputOption[] = [
    { label: `Without Image Gallery`, value: false },
    { label: `With Image Gallery`, value: true },
  ];

  const onChange = (val: DropdownInputOption) => {
    setProps((draft) => {
      draft.settings.showGallery = val.value as boolean;
    });
  };

  return (
    <DropdownInput
      theme={InputsDarkTheme}
      options={options}
      defaultValue={showGallery ? options[1] : options[0]}
      onChange={onChange}
      optionStyles={{ textTransform: `uppercase` }}
    />
  );
}
